/* eslint-disable brace-style */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getPriceChangesData } from "src/api/bi";
import {
  PriceChangesInitialState,
  PriceChangesDataRequestParams
} from "../../../config/tableInterface/interface";
import { postExportReport } from "src/api/sp";
import { resetStore } from "src/store/actions";
import stringToNumber from "../../../utils/stringToNumber";
import { formatToCurrency, getComponentKey } from "src/utils/genericFunctions";

export const fetchPriceChangesData = createAsyncThunk(
  "reports/fetchPriceChangesData",
  (payload: PriceChangesDataRequestParams) => getPriceChangesData(payload)
);

export const postingExportPriceChangesReportData = createAsyncThunk(
  "dashboard/postDailySalesData",
  (payload: any) => postExportReport(payload)
);

const initialState: PriceChangesInitialState = {
  data: null,
  recordsCount: null,
  status: "idle",
  error: null
};

const priceChangesData = createSlice({
  name: "viewNoSaleData",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(resetStore, (state, action) => {
        return initialState;
      })
      .addCase(fetchPriceChangesData.pending, (state) => {
        state.status = "pending";
        state.data = [];
      })
      .addCase(fetchPriceChangesData.fulfilled, (state, { payload }) => {
        /* istanbul ignore next */
        try {
          if (payload?.data?.length > 0) {
            state.status = "idle";
            state.data = payload.data.map((data: any) => {
              const newRetail = stringToNumber(data?.newRetail);
              const oldRetail = stringToNumber(data?.oldRetail);
              const units = +data?.units || 0;
              const extRetailPrice = (newRetail - oldRetail) * units;
              const exPriceChange = formatToCurrency(extRetailPrice);
              return {
                ...data,
                exPriceChange,
                description: data?.itemDesc,
                newRetail: formatToCurrency(newRetail),
                oldRetail: formatToCurrency(oldRetail),
                key: getComponentKey()
              };
            });
            state.recordsCount = payload.recordsCount;
          } else {
            state.data = [];
            state.status = "error";
          }
        } catch (e) {
          console.error(e);
          state.status = "error";
        }
      })
      .addCase(fetchPriceChangesData.rejected, (state) => {
        state.status = "error";
        state.data = [];
      })
      .addCase(
        postingExportPriceChangesReportData.fulfilled,
        (state, { payload }) => {
          state.status = "idle";
        }
      )
      .addCase(postingExportPriceChangesReportData.rejected, (state) => {
        state.status = "error";
      });
  }
});

export default priceChangesData.reducer;
